import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";

import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

export interface PhaseAngleInformation_TJ360VersionDeviceModel {
    mainid: string,
    deviceNo: string,
    Io1: string,
    pa1: string,
    ior1: string,
    Io2: string,
    pa2: string,
    ior2: string,
    Io3: string,
    pa3: string,
    ior3: string,
    Io4: string,
    pa4: string,
    ior4: string,
    Io5: string,
    pa5: string,
    ior5: string,
    Io6: string,
    pa6: string,
    ior6: string,
    lastGetDatetime: string,
}

const NO_OF_POLLING_TOPIC = 9;
const fetchId = "PHASE_ANGLE_INFORMATION_FETCH";

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    centralId: "",
    deviceNo: "",
    isRefreshAllCompleted: (status: number) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}

type PhaseAngleInformationProps = {
    defaultData: PhaseAngleInformation_TJ360VersionDeviceModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PurePhaseAngleInformationProps = PhaseAngleInformationProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const PhaseAngleInformation_TJ360VersionDevice = (props: PurePhaseAngleInformationProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn, centralId, deviceNo, isRefreshSuccessDeviceNo } = props;
    const { onError, onRefresh, isRefreshAllCompleted, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [phaseAngleInformation, setPhaseAngleInformation] = React.useState<PhaseAngleInformation_TJ360VersionDeviceModel | null>(fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);
    
    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PW";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        setRefreshFlg(false);

        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            Io1: data.Io1,
            pa1: data.pa1,
            ior1: data.ior1,
            Io2: data.Io2,
            pa2: data.pa2,
            ior2: data.ior2,
            Io3: data.Io3,
            pa3: data.pa3,
            ior3: data.ior3,
            Io4: data.Io4,
            pa4: data.pa4,
            ior4: data.ior4,
            Io5: data.Io5,
            pa5: data.pa5,
            ior5: data.ior5,
            Io6: data.Io6,
            pa6: data.pa6,
            ior6: data.ior6,
            lastGetDatetime: data.last_get_datetime,
        } as PhaseAngleInformation_TJ360VersionDeviceModel;

        setPhaseAngleInformation(resData);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setRefreshFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin > 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setRefreshFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any) => {
        handleFetchSuccess(data, true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        props.onRefreshComplete?.();
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }
    
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(refreshFlg, fetchId);
        // eslint-disable-next-line
    }, [refreshFlg]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        if(!defaultData) {
            setPhaseAngleInformation(null);}
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='PhaseAngle情報'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch1 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch1 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch1 Ior漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch2 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch2 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch2 Ior漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch3 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch3 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch3 Ior漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch4 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch4 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch4 Ior漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch5 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch5 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch5 Ior漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch6 Io漏電値</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch6 位相角</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Ch6 Ior漏電値</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch1 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io1}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch1 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa1}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch1 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior1}</td>
                                </tr>
                                
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch2 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io2}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch2 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa2}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch2 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior2}</td>
                                </tr>

                                <tr>
                                    <td style={pollingColStyleTitle}>Ch3 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io3}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch3 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa3}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch3 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior3}</td>
                                </tr>

                                <tr>
                                    <td style={pollingColStyleTitle}>Ch4 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io4}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch4 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa4}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch4 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior4}</td>
                                </tr>

                                <tr>
                                    <td style={pollingColStyleTitle}>Ch5 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io5}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch5 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa5}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch5 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior5}</td>
                                </tr>

                                <tr>
                                    <td style={pollingColStyleTitle}>Ch6 Io漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.Io6}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch6 位相角</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.pa6}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Ch6 Ior漏電値</td>
                                    <td style={pollingColStyle}>{phaseAngleInformation?.ior6}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{phaseAngleInformation?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});

const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `PhaseAngle情報取得`,
            body: "PhaseAngle情報取得できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PhaseAngleInformation_TJ360VersionDevice);

